import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/style.scss';
import './assets/css/responsive.scss';
import './assets/css/tinyeditor-custom.scss';
import { Provider } from 'react-redux';
import { store } from "./store";
import { Toaster } from 'react-hot-toast';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { APP_CURRENCY_CODE, PAYPAL_CLIENT_ID } from './_config/site_urls';
import { HelmetProvider } from "react-helmet-async";


const rootElement = document.getElementById('root') as HTMLElement;

const app = (
  // <HelmetProvider>
  <Provider store={store}>
    <PayPalScriptProvider options={{ clientId: PAYPAL_CLIENT_ID, currency: APP_CURRENCY_CODE }}>
      <App />
    </PayPalScriptProvider>
    <Toaster position="top-center" reverseOrder={false} />
  </Provider>
  // </HelmetProvider>
);

// public/index.html seeds #root with a static loader (id="static-app-loader") so
// first paint is never blank. react-snap always overwrites that placeholder with
// real rendered markup before saving a route's index.html — if it's still present,
// this is the raw template with nothing real to hydrate against.
const isRawTemplate = !!document.getElementById('static-app-loader');

if (rootElement.hasChildNodes() && !isRawTemplate) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
